import axios from 'axios';

// Environment-specific API configuration
const getApiBaseUrl = () => {
  return process.env.REACT_APP_BASE_URL || 'http://localhost:8080';
};

export const API_BASE_URL = getApiBaseUrl();

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Important for cookies
});

// Request interceptor to add access token to headers
api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401  && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Create a new axios instance for refresh to avoid infinite loop
        const refreshApi = axios.create({
          baseURL: API_BASE_URL,
          withCredentials: true,
        });
        
        const response = await refreshApi.post('/token/refresh');
        const { access_token } = response.data;
        
        localStorage.setItem('accessToken', access_token);
        
        // Retry the original request with new token
        originalRequest.headers.Authorization = `Bearer ${access_token}`;
        return api(originalRequest);
      } catch (refreshError) {
        // Refresh failed, redirect to login
        localStorage.removeItem('accessToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('orgsAndTokens');
        window.location.reload();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api; 